import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { useAuth, type UserRole } from './useAuth.js';

type Props = {
  allowed: UserRole[];
  children: ReactNode;
};

export function RequireRole({ allowed, children }: Props): JSX.Element {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen supports-[height:100dvh]:min-h-dvh items-center justify-center bg-edal-navy-50">
        <div className="rounded-lg border border-edal-navy-200 bg-white px-6 py-4 text-edal-navy-600">
          טוען...
        </div>
      </div>
    );
  }

  if (!user || !allowed.includes(user.role)) {
    return (
      <div className="flex min-h-screen supports-[height:100dvh]:min-h-dvh items-center justify-center bg-edal-navy-50">
        <div className="max-w-md rounded-lg border border-edal-orange-200 bg-white p-8 text-center">
          <h1 className="text-2xl font-bold text-edal-orange-600">אין הרשאה</h1>
          <p className="mt-2 text-edal-navy-700">אין לך הרשאה לצפות בדף זה.</p>
          <Link
            to="/app"
            className="mt-4 inline-block text-edal-orange-600 hover:text-edal-orange-700"
          >
            חזרה לדשבורד
          </Link>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
